import { Component, computed, inject, input } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faInfinity } from "@fortawesome/free-solid-svg-icons";
import { UserRoles } from "src/app/core/models/user.model";
import { SessionStorageService } from "src/app/core/services/session-storage.service";

@Component({
  selector: 'wf-remaining-subscriptions',
  standalone: true,
  imports: [
    FontAwesomeModule
  ],
  styleUrl: 'remaining-subscriptions.component.css',
  template: `
    <div class="remaining-subscriptions">
      <h4> {{ subscriptionsType() === 'diagnostic' ? 'Diagnostic' : 'System' }} </h4>
      <span>{{ subscriptionDescription() }}</span>
      <span class="remaining-subscriptions-count">
        @if (remaining() === -1) {
          <fa-icon [icon]="infinityIcon"/>
        } @else if (remaining() === -2) {
          0
        } @else { {{ remaining() }} }
      </span>
    </div>
  `
})
export class RemainingSubscriptionsComponent {
  readonly subscriptionsType = input.required<"diagnostic" | "system">();
  readonly remaining = input.required<number>();

  readonly user = inject(SessionStorageService).userData;
  readonly subscriptionDescription = computed(() => {
    const user = this.user();
    if (!user) {
      return "";
    }
    if (user.userRole === UserRoles.SCHOOL_ADMIN || user.effectiveUserRole === UserRoles.SCHOOL_ADMIN || user.userRole === UserRoles.CUSTOMER_SERVICE) {
      return "Remaining School Subscriptions";
    }
    return "Your Remaining Subscriptions";
  });

  protected readonly infinityIcon = faInfinity;
}
